<template>
  <div :class="$style.container">
    <textarea v-model="comment" :class="$style.comment" @input="onInput" placeholder="Введите текст..."></textarea>
    <div :class="[$style.loading, status && $style.loadingActive]">
      <span v-if="status === 'save'">Сохранение...</span>
      <span v-if="status === 'done'">Сохранено</span>
    </div>
  </div>
</template>

<script>
import _debounce from "lodash/debounce";

export default {
  name:  "PaymentComment",
  props: ['value', 'onChange'],
  data() {
    return {
      comment: this.value || '',
      status:  null,
    };
  },
  methods: {
    onInput() {
      this.status = 'save';
      this.update();
    },
  },
  mounted() {
    this.update = _debounce(() => {
      if (this.comment === this.value) {
        this.status = null;
        return;
      }
      this.onChange(this.comment).then(() => {
        this.status = 'done';
        setTimeout(() => this.status = null, 2000);
      });
    }, 1000);
  },
  watch: {
    value() {
      this.comment = this.value || '';
    },
  },
};
</script>

<style lang="scss" module>
.container {
  position: relative;
}

.comment {
  display: block;
  border: 0;
  resize: none;
  min-width: 100%;
  max-width: 100%;
  padding: 20px;
  font: inherit;
  word-wrap: break-word;
  white-space: pre-line;
}

.loading {
  font-size: 1.05rem;
  position: absolute;
  right: 20px;
  bottom: 15px;
  opacity: 0;
  pointer-events: none;
  @include anim()
}

.loadingActive {
  opacity: 1;
}
</style>
